import Top from 'src/views/Top'
import Login from 'src/views/Login'

import RojouTenken from 'src/views/RojouTenken'
import RojouTenkenList from 'src/views/RojouTenken/RojouTenkenList'
import RojouTenkenDetailList from 'src/views/RojouTenken/RojouTenkenDetailList'
import RojouTenkenDetail from 'src/views/RojouTenken/RojouTenkenDetail'

import RokaTenken from 'src/views/RokaTenken'
import RokaTenkenList from 'src/views/RokaTenken/RokaTenkenList'
import RokaTenkenDetailList from 'src/views/RokaTenken/RokaTenkenDetailList'
import RokaTenkenDetail from 'src/views/RokaTenken/RokaTenkenDetail'

import KoukashitaTenken from 'src/views/KoukashitaTenken'
import KoukashitaTenkenList from 'src/views/KoukashitaTenken/KoukashitaTenkenList'
import KoukashitaTenkenDetailList from 'src/views/KoukashitaTenken/KoukashitaTenkenDetailList'
import KoukashitaTenkenDetail from 'src/views/KoukashitaTenken/KoukashitaTenkenDetail'

import TenkenReport from 'src/views/TenkenReport'
import HoshuReport from 'src/views/HoshuReport'
import Search from 'src/views/Search'

import Admin from 'src/views/Admin'
import AdminTop from 'src/views/Admin/Top'
import AdminStaff from 'src/views/Admin/Staff'
import AdminTantoujimusho from 'src/views/Admin/Tantoujimusho'
import AdminRosen from 'src/views/Admin/Rosen'
import AdminRosenHoukou from 'src/views/Admin/RosenHoukou'
import AdminShasenKubun from 'src/views/Admin/ShasenKubun'
import AdminRosenjimusho from 'src/views/Admin/Rosenjimusho'
import AdminTenkenKubun from 'src/views/Admin/TenkenKubun'
import AdminHasonjoukyou from 'src/views/Admin/Hasonjoukyou'
import AdminDobokuSuuryou from 'src/views/Admin/DobokuSuuryou'
import AdminHasonbasho from 'src/views/Admin/Hasonbasho'
import AdminHantei from 'src/views/Admin/Hantei'
import AdminHonsenranpuKubun from 'src/views/Admin/HonsenranpuKubun'
import AdminBui from 'src/views/Admin/Bui'
import AdminUkeoigyousha from 'src/views/Admin/Ukeoigyousha'
import AdminShinshukutsugite from 'src/views/Admin/Shinshukutsugite'
import AdminKiji from 'src/views/Admin/Kiji'
import AdminTekiyou from 'src/views/Admin/Tekiyou'
import AdminBase from 'src/views/Admin/Base'
import AdminPole from 'src/views/Admin/Pole'
import AdminJoint from 'src/views/Admin/Joint'
import AdminEmergencyTel from 'src/views/Admin/EmergencyTel'

const routes = [
  {
    path: '/',
    name: 'Top',
    component: Top,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/rojou-tenken',
    name: 'RojouTenken',
    component: RojouTenken,
    redirect: { name: 'RojouTenkenList' },
    children: [
      {
        path: '/rojou-tenken',
        name: 'RojouTenkenList',
        component: RojouTenkenList,
      },
      {
        path: '/rojou-tenken/:base_id/detail',
        name: 'RojouTenkenDetailList',
        component: RojouTenkenDetailList,
      },
      {
        path: '/rojou-tenken/:base_id/detail/new',
        name: 'RojouTenkenDetailNew',
        component: RojouTenkenDetail,
      },
      {
        path: '/rojou-tenken/:base_id/detail/:detail_id',
        name: 'RojouTenkenDetail',
        component: RojouTenkenDetail,
      },
    ]
  },
  {
    path: '/roka-tenken',
    name: 'RokaTenken',
    component: RokaTenken,
    redirect: { name: 'RokaTenkenList' },
    children: [
      {
        path: '/roka-tenken',
        name: 'RokaTenkenList',
        component: RokaTenkenList,
      },
      {
        path: '/roka-tenken/:base_id/detail',
        name: 'RokaTenkenDetailList',
        component: RokaTenkenDetailList,
      },
      {
        path: '/roka-tenken/:base_id/detail/new',
        name: 'RokaTenkenDetailNew',
        component: RokaTenkenDetail,
      },
      {
        path: '/roka-tenken/:base_id/detail/:detail_id',
        name: 'RokaTenkenDetail',
        component: RokaTenkenDetail,
      },
    ]
  },
  {
    path: '/koukashita-tenken',
    name: 'KoukashitaTenken',
    component: KoukashitaTenken,
    redirect: { name: 'KoukashitaTenkenList' },
    children: [
      {
        path: '/koukashita-tenken',
        name: 'KoukashitaTenkenList',
        component: KoukashitaTenkenList,
      },
      {
        path: '/koukashita-tenken/:base_id/detail',
        name: 'KoukashitaTenkenDetailList',
        component: KoukashitaTenkenDetailList,
      },
      {
        path: '/koukashita-tenken/:base_id/detail/new',
        name: 'KoukashitaTenkenDetailNew',
        component: KoukashitaTenkenDetail,
      },
      {
        path: '/koukashita-tenken/:base_id/detail/:detail_id',
        name: 'KoukashitaTenkenDetail',
        component: KoukashitaTenkenDetail,
      },
    ]
  },
  {
    path: '/tenken-report',
    name: 'TenkenReport',
    component: TenkenReport,
  },
  {
    path: '/hoshu-report',
    name: 'HoshuReport',
    component: HoshuReport,
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    redirect: { name: 'AdminTop' },
    children: [
      {
        path: '/admin',
        name: 'AdminTop',
        component: AdminTop,
      },
      {
        path: '/admin/staff',
        name: 'AdminStaff',
        component: AdminStaff,
      },
      {
        path: '/admin/tantoujimusho',
        name: 'AdminTantoujimusho',
        component: AdminTantoujimusho,
      },
      {
        path: '/admin/rosen',
        name: 'AdminRosen',
        component: AdminRosen,
      },
      {
        path: '/admin/rosen-houkou',
        name: 'AdminRosenHoukou',
        component: AdminRosenHoukou,
      },
      {
        path: '/admin/shasen-kubun',
        name: 'AdminShasenKubun',
        component: AdminShasenKubun,
      },
      {
        path: '/admin/rosenjimusho',
        name: 'AdminRosenjimusho',
        component: AdminRosenjimusho,
      },
      {
        path: '/admin/tenken-kubun',
        name: 'AdminTenkenKubun',
        component: AdminTenkenKubun,
      },
      {
        path: '/admin/hasonjoukyou',
        name: 'AdminHasonjoukyou',
        component: AdminHasonjoukyou,
      },
      {
        path: '/admin/doboku-suuryou',
        name: 'AdminDobokuSuuryou',
        component: AdminDobokuSuuryou,
      },
      {
        path: '/admin/hasonbasho',
        name: 'AdminHasonbasho',
        component: AdminHasonbasho,
      },
      {
        path: '/admin/hantei',
        name: 'AdminHantei',
        component: AdminHantei,
      },
      {
        path: '/admin/honsenranpu-kubun',
        name: 'AdminHonsenranpuKubun',
        component: AdminHonsenranpuKubun,
      },
      {
        path: '/admin/bui',
        name: 'AdminBui',
        component: AdminBui,
      },
      {
        path: '/admin/ukeoigyousha',
        name: 'AdminUkeoigyousha',
        component: AdminUkeoigyousha,
      },
      {
        path: '/admin/shinshukutsugite',
        name: 'AdminShinshukutsugite',
        component: AdminShinshukutsugite,
      },
      {
        path: '/admin/kiji',
        name: 'AdminKiji',
        component: AdminKiji,
      },
      {
        path: '/admin/tekiyou',
        name: 'AdminTekiyou',
        component: AdminTekiyou,
      },
      {
        path: '/admin/base',
        name: 'AdminBase',
        component: AdminBase,
      },
      {
        path: '/admin/pole',
        name: 'AdminPole',
        component: AdminPole,
      },
      {
        path: '/admin/joint',
        name: 'AdminJoint',
        component: AdminJoint,
      },
      {
        path: '/admin/emergency_tel',
        name: 'AdminEmergencyTel',
        component: AdminEmergencyTel,
      },
    ]
  },
  // catch all
  {
    path: '*',
    redirect: { name: 'Login' },
  }
]

export default routes
